import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  '@global': {
    'a': {
      '&:active': {
        textDecoration: 'none',
      },
      '&:focus-visible': {
        outline: 0,
        outlineOffset: 0,
      },
    },
  },
}));

export default useStyles;
